import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Shield, TrendingUp } from 'lucide-react';

const HeroSection = ({ onScheduleDemo }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0f1a36] via-[#1a2847] to-[#0f1a36]">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#007bff] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute top-40 right-20 w-96 h-96 bg-[#008080] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-1000"></div>
        <div className="absolute -bottom-32 left-1/3 w-80 h-80 bg-[#007bff] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-2000"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-8">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <Shield className="w-4 h-4 text-[#008080]" />
              <span className="text-sm font-medium">Sistema de Gestão de Transporte Condominial</span>
            </div>
            
            <h1 className="text-6xl text-white tracking-tight font-['Sora']">
  <span className="font-extrabold">WCOM</span>
  <span className="font-normal">Pass</span>
</h1>
            
            <p className="text-xl lg:text-2xl text-gray-300 leading-relaxed">
              Governança operacional completa para transporte de condomínios com tecnologia NFC, rastreabilidade em tempo real e controle total de acesso.
            </p>

            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-lg bg-[#007bff]/20 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-[#007bff]" />
                </div>
                <div>
                  <p className="font-semibold text-lg">Mais Segurança</p>
                  <p className="text-gray-400 text-sm">Controle de acesso com NFC</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-lg bg-[#008080]/20 flex items-center justify-center flex-shrink-0">
                  <TrendingUp className="w-6 h-6 text-[#008080]" />
                </div>
                <div>
                  <p className="font-semibold text-lg">Redução de Custos</p>
                  <p className="text-gray-400 text-sm">Otimização operacional</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                size="lg" 
                onClick={onScheduleDemo}
                className="bg-[#007bff] hover:bg-[#0056b3] text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                Agendar Demo
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => document.getElementById('funcionalidades')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg font-semibold rounded-lg backdrop-blur-sm transition-all duration-300"
              >
                Conhecer Funcionalidades
              </Button>
            </div>
          </div>

          {/* Right Content - Image placeholder */}
          <div className="relative lg:block hidden">
            <div className="relative w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-sm">
              <img 
                src="https://wcompass.com.br/img/fundo-login.jpg" 
                alt="WCOMPass Sistema"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a36] via-transparent to-transparent"></div>
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                  <Shield className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">100%</p>
                  <p className="text-sm text-gray-600">Rastreabilidade</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
